import { render, staticRenderFns } from "./customer_edit.vue?vue&type=template&id=188d7f55&scoped=true"
import script from "./customer_edit.vue?vue&type=script&lang=js"
export * from "./customer_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188d7f55",
  null
  
)

export default component.exports